import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import _axios, { setToken } from '@/plugins/axios'
import qs from 'qs'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    is_authorised: false,
    user: {},
    materialCategories: [],
    materials: [],
    products: [],
    productCategories: [],
  },
  getters: {
    is_authorised: (state) => state.is_authorised,
    access_token: (state) => state.access_token,
    materialCategories: (state) => state.materialCategories,
    materials: (state) => state.materials,
    productCategories: (state) => state.productCategories,
    products: (state) => state.products,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    login(state, { token, user }) {
      state.is_authorised = true
      state.access_token = token
      state.user = user
    },
    LOG_OUT(state) {
      state.is_authorised = false
      state.access_token = ''
      state.refresh_token = ''
    },
    setMaterialCategories(state, data) {
      state.materialCategories = data
    },
    setMaterials(state, data) {
      state.materials = data
    },
    setProductCategories(state, data) {
      state.productCategories = data
    },
    setProducts(state, data) {
      state.products = data
    },
  },
  actions: {
    login: async ({ commit }, { email, password }) => {
      let response = await _axios.post('login', {
        email,
        password,
        remember: true,
      })
      if (
        response.data.status_code === 200 &&
        response.data.data.access_token
      ) {
        const token = response.data.data.access_token
        commit('login', {
          token,
          user: response.data.data.user,
        })
        setToken(token)
        return true
      }
      return false
    },
    logout: ({ commit }) => {
      commit('LOG_OUT')
    },
    getMaterialCategories({ commit }) {
      _axios
        .get('categories', { params: { type: 'material' } })
        .then(({ data }) => {
          commit('setMaterialCategories', data.data)
        })
    },
    getMaterials({ commit }, { filter }) {
      _axios.get('materials?' + qs.stringify({ filter })).then(({ data }) => {
        commit('setMaterials', data)
      })
    },
    getProductCategories({ commit }) {
      _axios
        .get('categories', { params: { type: 'product' } })
        .then(({ data }) => {
          commit('setProductCategories', data.data)
        })
    },
    getProducts({ commit }, { page, perPage, filter }) {
      console.log(page)
      _axios
        .get('products?' + qs.stringify({ page, per_page: perPage, filter }))
        .then(({ data }) => {
          commit('setProducts', data)
        })
    },
  },
  modules: {},
  plugins: [
    createPersistedState({
      key: 'frog-admin',
    }),
  ],
})
